import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  errorNotification: 'Settings could not be saved. Please try again.',
  heading: 'GST',
  successNotification: 'Settings saved successfully.',
  taxApplicableLabel: 'New items are GST Applicable',
  taxApplicableDescription:
    'Existing items will not be affected by these settings. You will be able to change the setting for individual items later.',
  taxPriceLabel: 'GST Price Display',
  taxPriceDescription:
    'Choose whether item prices are displayed to customers with GST included or excluded by default. Note that changing these settings will affect new invoices, but existing invoices will not be impacted.',
  taxInclusive: 'GST Included',
  taxExclusive: 'GST Excluded',
  taxInfoMessage:
    'The price for {itemsCount} items will be updated to be {taxStatus}.',
  taxInfoMessageNoItems:
    'Item prices will be displayed to customers with {taxStatus}.',
  itemManagement: 'Item Management',
  autoGenerateSkuLabel: 'Automatically Generate SKUs',
  autoGenerateSkuDescription:
    'Automatically Generate SKUs for any new items. Existing items will not be affected by these settings',
})
